<div>
    <app-shared-attachments
    [departmentType]="departmentType" 
    [sessionType]="sessionType"
    ></app-shared-attachments>
</div>
